//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param vestigingId (optional) 
     * @return OK
     */
    list_all_featurestates(vestigingId: string | null | undefined): Promise<FeatureStatesOutput> {
        let url_ = this.baseUrl + "/Features";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList_all_featurestates(_response);
        });
    }

    protected processList_all_featurestates(response: Response): Promise<FeatureStatesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeatureStatesOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeatureStatesOutput>(null as any);
    }

    /**
     * @return OK
     */
    define_Feature(body: FeatureDefinition): Promise<boolean> {
        let url_ = this.baseUrl + "/Features";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDefine_Feature(_response);
        });
    }

    protected processDefine_Feature(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    display_all_features(): Promise<FeaturesAvailableOutput> {
        let url_ = this.baseUrl + "/Features/available";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDisplay_all_features(_response);
        });
    }

    protected processDisplay_all_features(response: Response): Promise<FeaturesAvailableOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeaturesAvailableOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeaturesAvailableOutput>(null as any);
    }

    /**
     * @param vestigingId (optional) 
     * @return OK
     */
    check_Feature(feature: string, vestigingId: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Features/{feature}";
        if (feature === undefined || feature === null)
            throw new Error("The parameter 'feature' must be defined.");
        url_ = url_.replace("{feature}", encodeURIComponent("" + feature));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheck_Feature(_response);
        });
    }

    protected processCheck_Feature(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param vestigingId (optional) 
     * @param enabled (optional) 
     * @return OK
     */
    toggle_Feature(feature: string, vestigingId: string | null | undefined, enabled: boolean | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Features/{feature}?";
        if (feature === undefined || feature === null)
            throw new Error("The parameter 'feature' must be defined.");
        url_ = url_.replace("{feature}", encodeURIComponent("" + feature));
        if (enabled !== undefined && enabled !== null)
            url_ += "enabled=" + encodeURIComponent("" + enabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToggle_Feature(_response);
        });
    }

    protected processToggle_Feature(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    remove_Feature(feature: string): Promise<boolean> {
        let url_ = this.baseUrl + "/Features/{feature}";
        if (feature === undefined || feature === null)
            throw new Error("The parameter 'feature' must be defined.");
        url_ = url_.replace("{feature}", encodeURIComponent("" + feature));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemove_Feature(_response);
        });
    }

    protected processRemove_Feature(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param correlationId (optional) 
     * @param jsonValues (optional) 
     * @param attachment (optional) 
     * @return Created
     */
    post_BusCommand(vestigingId: string, correlationId: string | null | undefined, busCommand: string, jsonValues: string | null | undefined, attachment: FileParameter | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/FrontBus/{busCommand}";
        if (busCommand === undefined || busCommand === null)
            throw new Error("The parameter 'busCommand' must be defined.");
        url_ = url_.replace("{busCommand}", encodeURIComponent("" + busCommand));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (jsonValues !== null && jsonValues !== undefined)
            content_.append("JsonValues", jsonValues.toString());
        if (attachment !== null && attachment !== undefined)
            content_.append("Attachment", attachment.data, attachment.fileName ? attachment.fileName : "Attachment");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "correlationId": correlationId !== undefined && correlationId !== null ? "" + correlationId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_BusCommand(_response);
        });
    }

    protected processPost_BusCommand(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * @return Created
     * @deprecated
     */
    nieuwe_aanvraag(vestigingId: string, body: NieuweAanvraagInput): Promise<NewOutput> {
        let url_ = this.baseUrl + "/HdnOnline/bus/NieuweAanvraag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNieuwe_aanvraag(_response);
        });
    }

    protected processNieuwe_aanvraag(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * @param correlationId (optional) 
     * @param documentId (optional) 
     * @param attachement (optional) 
     * @return Created
     * @deprecated
     */
    nieuw_document_voor_aanvraag(vestigingId: string, correlationId: string | null | undefined, documentId: string | null | undefined, attachement: FileParameter | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/HdnOnline/bus/NieuwDocumentVoorAanvraag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (correlationId !== null && correlationId !== undefined)
            content_.append("CorrelationId", correlationId.toString());
        if (documentId !== null && documentId !== undefined)
            content_.append("DocumentId", documentId.toString());
        if (attachement !== null && attachement !== undefined)
            content_.append("Attachement", attachement.data, attachement.fileName ? attachement.fileName : "Attachement");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNieuw_document_voor_aanvraag(_response);
        });
    }

    protected processNieuw_document_voor_aanvraag(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * @param correlationId (optional) 
     * @return Created
     * @deprecated
     */
    opnieuw_aanbieden_bericht(vestigingId: string, berichtId: string, correlationId: string | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/HdnOnline/bus/RetryBericht/{berichtId}?";
        if (berichtId === undefined || berichtId === null)
            throw new Error("The parameter 'berichtId' must be defined.");
        url_ = url_.replace("{berichtId}", encodeURIComponent("" + berichtId));
        if (correlationId !== undefined && correlationId !== null)
            url_ += "correlationId=" + encodeURIComponent("" + correlationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOpnieuw_aanbieden_bericht(_response);
        });
    }

    protected processOpnieuw_aanbieden_bericht(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * @return Created
     */
    nieuwe_hypotheekvergelijking(vestigingId: string, body: HypotheekvergelijkerInput): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Hypotheekvergelijker/bus/Hypotheekvergelijker";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNieuwe_hypotheekvergelijking(_response);
        });
    }

    protected processNieuwe_hypotheekvergelijking(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * @return OK
     */
    getVersionInfo(): Promise<VersionInfo> {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersionInfo(_response);
        });
    }

    protected processGetVersionInfo(response: Response): Promise<VersionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BadRequestResult;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionInfo>(null as any);
    }

    /**
     * @return OK
     */
    getFoutcodes(): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/VersionInfo/FoutCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFoutcodes(_response);
        });
    }

    protected processGetFoutcodes(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }
}

export interface AanvullendAntwoord {
    xPath: string | null;
    parentOccurance: number | null;
    waarde: any | null;
}

/** AflossingsVormType Geen = 0, Annuïteit = 1, Lineair = 2, Levensverzekering = 3, Spaar = 4, Aflosvrij = 5, Krediet = 9, Belegging = 10, Hybride = 11, UnitLinked = 12, Spaarrekening = 13, AnnuïteitUitgesteld = 20, AnnuïteitBlok = 21, KredietNoPay = 22 */
export enum AflossingsVormType {
    Geen = "Geen",
    Annuïteit = "Annuïteit",
    Lineair = "Lineair",
    Levensverzekering = "Levensverzekering",
    Spaar = "Spaar",
    Aflosvrij = "Aflosvrij",
    Krediet = "Krediet",
    Belegging = "Belegging",
    Hybride = "Hybride",
    UnitLinked = "UnitLinked",
    Spaarrekening = "Spaarrekening",
    AnnuïteitUitgesteld = "AnnuïteitUitgesteld",
    AnnuïteitBlok = "AnnuïteitBlok",
    KredietNoPay = "KredietNoPay",
}

export interface BadRequestResult {
    statusCode: number;
}

export interface ConfirmImportTaak {
    koppelingKey: string;
    importTaakId: string;
}

export interface FeatureDefinition {
    name: string | null;
    description: string | null;
    enabledForApplication: boolean | null;
    availableForUsers: boolean;
    optIn: boolean | null;
    optOut: boolean | null;
    users: string[] | null;
    groups: string[] | null;
}

export interface FeatureStatesOutput {
    featureStates: { [key: string]: boolean; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface FeaturesAvailableOutput {
    features: FeatureDefinition[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface HypotheekRenteaftrek {
    renteaftrekId: string | null;
    volgnummer: number;
    bedrag: number | null;
    aanvangsdatum: string;
    einddatum: string;
}

export interface HypotheekvergelijkerContractrente {
    offerterente: boolean;
    dagrente: boolean;
    dalrente: boolean;
}

export interface HypotheekvergelijkerFiscaleVoortzetting {
    ingebrachteWaardeBedrag: number | null;
}

export interface HypotheekvergelijkerInput {
    correlationId: string;
    voorstelId: string;
    adviesdossierId: string;
    leningdelen: HypotheekvergelijkerLeningdeel[];
    verklaringInkomen: HypotheekvergelijkerVerklaringInkomen | null;
    contractrente: HypotheekvergelijkerContractrente | null;
    offerte: HypotheekvergelijkerOfferte | null;
    overig: HypotheekvergelijkerOverig | null;
}

export interface HypotheekvergelijkerLeningdeel {
    hypotheekvorm: Hypotheekvorm | null;
    doorlopend: boolean;
    aanvangsdatum: string | null;
    aflossingsvorm: AflossingsVormType | null;
    leningdeelBedrag: number | null;
    rentevariant: RentevariantOptions;
    rentevastperiodeInJaren: number | null;
    looptijdInMaanden: number | null;
    deelBox1Bedrag: number | null;
    starterslening: boolean;
    restschuldFinanciering: boolean;
    fiscaleVoortzetting: HypotheekvergelijkerFiscaleVoortzetting | null;
    renteaftrekken: HypotheekRenteaftrek[] | null;
}

export interface HypotheekvergelijkerOfferte {
    minimaleOffertegeldigheidsduur: boolean;
    minimaleGeldigheidsduurInMaanden: number | null;
    inclusiefVerlengingsduur: boolean | null;
}

export interface HypotheekvergelijkerOverig {
    annuleringskostenOfferte: boolean | null;
    verplichteOrv: boolean | null;
    verhuisregeling: boolean | null;
}

export interface HypotheekvergelijkerVerklaringInkomen {
    werkgever: boolean;
    uwv: boolean;
    perspectief: boolean;
    accountantsverklaring: boolean;
    ibStukken: boolean;
}

export interface Hypotheekvorm {
    code: number;
    omschrijving: string | null;
    aflossingsvorm: AflossingsVormType | null;
    renteboxCode: number;
    starterslening: boolean;
    restschuldFinanciering: boolean;
    heeftLooptijdInMaanden: boolean;
}

export interface NewOutput {
    id: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface NieuwAbcRapport {
    voorstelVolgNr: number;
}

export interface NieuwDocumentVoorAanvraag {
    documentId: string;
    bestandsNaam: string | null;
}

export interface NieuwRapport {
    adviesDossierId: string;
    voorstelId: string | null;
    rapportStructuurId: string;
    gewensteRapportNaam: string | null;
    preview: boolean;
}

export interface NieuweAanvraag {
    analyseId: string | null;
    dekkingId: string | null;
    adviesdossierId: string;
    ontvangerNrHdn: string | null;
    ontvangerNaam: string | null;
    maatschappijCode: string | null;
    nieuweVersie: boolean | null;
    softwareKoppelingId: string | null;
    externeReferentie: string | null;
    aanvullendeAntwoorden: AanvullendAntwoord[] | null;
}

export interface NieuweAanvraagInput {
    correlationId: string;
    voorstelId: string | null;
    dekkingId: string | null;
    adviesdossierId: string;
    ontvangerNrHdn: string | null;
    ontvangerNaam: string | null;
    maatschappijCode: string | null;
    externeReferentie: string | null;
    nieuweVersie: boolean | null;
    softwareKoppelingId: string | null;
    aanvullendeAntwoorden: AanvullendAntwoord[] | null;
}

export interface Operation {
    value: any | null;
    path: string | null;
    op: string | null;
    from: string | null;
}

export interface PatchImportTaak {
    koppelingKey: string;
    importTaakId: string;
    jsonPatchData: Operation[] | null;
    confirmAfterPatch: boolean;
}

/** RentevariantOptions Rentevast = 1, Rentedempend = 2, Variabel = 3 */
export enum RentevariantOptions {
    Rentevast = "Rentevast",
    Rentedempend = "Rentedempend",
    Variabel = "Variabel",
}

export interface RetryBericht {
    berichtId: string;
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}